import { toast } from "react-toastify";
import { reduce } from 'lodash';
import {
  fetchDonationService,
  fetchDonationFromSheetService,
  createDonationService,
  // fetchDonationSummaryService,
  // fetchCountryDonationSummary,
} from "./api";

import {
  FETCH_DONATION,
  FETCH_DONATION_FAILED,
  FETCH_DONATION_SUCCESS,
  CREATE_DONATION,
  CREATE_DONATION_FAILED,
  CREATE_DONATION_SUCCESS,
  FETCHING_DONATION_SUMMARY,
  FETCHING_DONATION_SUMMARY_FAILED,
  FETCHING_DONATION_SUMMARY_SUCCESS,

  FETCHING_COUNTRY_DONATION_SUMMARY,
  FETCHING_COUNTRY_DONATION_SUMMARY_FAILED,
  FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS,
} from "./types";


export const fetchDonationAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: FETCH_DONATION });
    const response = await fetchDonationService(params)();
    dispatch({ type: FETCH_DONATION_SUCCESS, donations: response?.data });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_DONATION_FAILED });
  }
};

export const fetchDonationFromSheetAction = (params) => async (dispatch) => {

  try {
    dispatch({ type: FETCH_DONATION });
    const response = await fetchDonationFromSheetService(params)();

    const reducedData = reduce(
      response.data.data,
      (result, subArray) => {
        return [
          {
            category: subArray[0],
            funding_source: subArray[1],
            funding_title: subArray[2],
            funding_description: subArray[3],
            amount: subArray[4],
            donation_type: subArray[7],
          },

          ...result,
        ];
      },
      []
    );
    dispatch({
      type: FETCH_DONATION_SUCCESS,
      donations: {
        data: reducedData,
        total: response.data.rowCount,
        lastPage: Math.ceil(response.data.rowCount / params.count),
        page: params.page,
        perPage: params.count,
      },
    });
    return true;
  } catch (error) {
    dispatch({ type: FETCH_DONATION_FAILED });
  }
};

export const fetchDonationForDownload = (params) => async (dispatch) => {
  try {
    const response = await fetchDonationService(params)();
    return [response?.data, null]
  } catch (error) {
    return [null, error]
  }
};

export const createDonationAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DONATION });
    const response = await createDonationService(params);
    dispatch({type: CREATE_DONATION_SUCCESS, donations: response?.data});
    toast.success('Donations Added')
  } catch (error) {
    dispatch({type: CREATE_DONATION_FAILED});
    toast.error('Add Donations Failed')
  }
};

export const fetchDonationSummaryAction = () => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_DONATION_SUMMARY });
    const response = await fetchDonationFromSheetService({
      sheetName: 'general summary'
    })();
    const data = response?.data?.data?.[1];
     const summaryData = {
       materialDonations: data[1],
      dataSet: data[2],
      vaccination: data[3],
      resourcesCommitted: data[0]
     }
    dispatch({
      type: FETCHING_DONATION_SUMMARY_SUCCESS,
      summary: summaryData,
    });
  } catch (error) {
    dispatch({ type: FETCHING_DONATION_SUMMARY_FAILED });
  }
};

export const fetchCountryDonationSummaryAction = (id) => async (dispatch) => {
  try {
    dispatch({ type: FETCHING_COUNTRY_DONATION_SUMMARY });
    const response = await fetchDonationFromSheetService({
      sheetName: 'country summary'
    })();
    const [_, ...rest] = response?.data?.data;
    const countrySummary = rest.reduce((prev, curr) => {
      return ({
        ...prev,
        [curr[0]?.toLowerCase()]: {
          dataSet: curr[1],
          resourceCommitted: curr[2],
          materialDonations: curr[3],
          vaccinaton: curr[4]
        }
      })
    }, {});

    dispatch({
      type: FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS,
      data: countrySummary,
    });
  } catch (error) {
    dispatch({ type: FETCHING_COUNTRY_DONATION_SUMMARY_FAILED });
  }
};
